import { render, staticRenderFns } from "./Montecristo.vue?vue&type=template&id=976adb00&scoped=true&"
import script from "./Montecristo.vue?vue&type=script&lang=js&"
export * from "./Montecristo.vue?vue&type=script&lang=js&"
import style0 from "./Montecristo.vue?vue&type=style&index=0&id=976adb00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976adb00",
  null
  
)

export default component.exports